import { IconProps } from '../Icons.type'

export function LineChartIcon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      fill="none"
      {...props}
      viewBox="0 0 21 21">
      <g
        stroke="#F5F5F5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        clipPath="url(#clip0_4058_102974)">
        <path d="M1.523 10.98a9.375 9.375 0 1018.75 0 9.375 9.375 0 00-18.75 0z"></path>
        <path d="M4.023 11.605h2.5l1.884-4.709a.624.624 0 011.166.024l2.744 7.771a.625.625 0 001.131.103l1.825-3.19h2.5"></path>
      </g>
      <defs>
        <clipPath id="clip0_4058_102974">
          <path
            fill="#fff"
            d="M0 0H20V20H0z"
            transform="translate(.898 .98)"></path>
        </clipPath>
      </defs>
    </svg>
  )
}
